type Props = {
    latitude: number
    longitude: number
    title?: string
    fillHeight?: boolean
    embedded?: boolean
    className?: string
}

function buildEmbedUrl(lat: number, lng: number): string {
    const delta = 0.006
    const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join(",")
    const params = new URLSearchParams({
        bbox,
        layer: "mapnik",
        marker: `${lat},${lng}`,
    })
    return `https://www.openstreetmap.org/export/embed.html?${params.toString()}`
}

export default function OsmMap({
    latitude,
    longitude,
    title = "Кинотеатр на карте",
    fillHeight = false,
    embedded = false,
    className = "",
}: Props) {
    const embedUrl = buildEmbedUrl(latitude, longitude)

    const frameClass = embedded
        ? "h-full min-h-[420px]"
        : fillHeight
          ? "min-h-[420px] aspect-[16/10] lg:aspect-auto lg:min-h-0 lg:h-full"
          : "aspect-[16/10]"

    return (
        <section
            className={`overflow-hidden bg-[#0d1a33] ${
                embedded
                    ? "h-full rounded-none border-0"
                    : "rounded-[24px] border border-white/10 bg-white/[0.04]"
            } ${className}`}>
            <div className={`relative w-full ${frameClass}`}>
                <iframe
                    title={title}
                    src={embedUrl}
                    className="absolute inset-0 h-full w-full border-0"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </section>
    )
}
